import { render, staticRenderFns } from "./album.component.html?vue&type=template&id=3beadd4a&scoped=true&"
import script from "./album.component.ts?vue&type=script&lang=ts&"
export * from "./album.component.ts?vue&type=script&lang=ts&"
import style0 from "./album.component.scss?vue&type=style&index=0&id=3beadd4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3beadd4a",
  null
  
)

export default component.exports